"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyPropertiesQuery = exports.useGetRequestLimitQuery = exports.getRequestLimitQuery = exports.useSaveCompanyPropertyQuery = exports.useGetCompanyPropertyWhitelistedDomainsQuery = exports.useSaveCompanyFeatureQuery = exports.useGetCompanyFeaturesQuery = exports.companyFeaturesQuery = exports.useSaveCompanyNameQuery = exports.companyKeys = void 0;
const react_query_1 = require("@tanstack/react-query");
const appConstants_1 = require("../constants/appConstants");
const companyRepository_1 = __importDefault(require("../repositories/companyRepository"));
const Root_1 = require("../router/Root");
const query_keys_1 = require("./query-keys");
const userQuery_1 = require("./userQuery");
exports.companyKeys = {
    getCompanyUsers: 'getCompanyUsers',
    getFeatures: () => ['company', 'features', 'all'],
    getProperties: ['company', 'properties', 'all'],
    getRequestLimit: ['company', 'properties', 'requestLimit'],
    getWhitelistedDomains: ['company', 'properties', 'whitelistedDomains'],
};
const useSaveCompanyNameQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: companyRepository_1.default.saveCompanyName,
        onSettled: () => Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.userKeys.getUser] }),
    });
};
exports.useSaveCompanyNameQuery = useSaveCompanyNameQuery;
exports.companyFeaturesQuery = (0, react_query_1.queryOptions)({
    queryKey: exports.companyKeys.getFeatures(),
    queryFn: companyRepository_1.default.getCompanyFeatures,
});
const useGetCompanyFeaturesQuery = () => {
    return (0, react_query_1.useQuery)(exports.companyFeaturesQuery);
};
exports.useGetCompanyFeaturesQuery = useGetCompanyFeaturesQuery;
const useSaveCompanyFeatureQuery = () => {
    return (0, react_query_1.useMutation)({ mutationFn: companyRepository_1.default.saveCompanyFeature });
};
exports.useSaveCompanyFeatureQuery = useSaveCompanyFeatureQuery;
const getCompanyPropertyWhitelistedDomainsQuery = (companyId) => {
    return {
        queryKey: [exports.companyKeys.getWhitelistedDomains, companyId],
        queryFn: () => companyRepository_1.default.getCompanyPropertyWhitelistedDomains({ companyId }),
    };
};
const useGetCompanyPropertyWhitelistedDomainsQuery = (companyId) => {
    const queryInfo = getCompanyPropertyWhitelistedDomainsQuery(companyId);
    return (0, react_query_1.useQuery)({
        ...queryInfo,
        enabled: Boolean(companyId),
    });
};
exports.useGetCompanyPropertyWhitelistedDomainsQuery = useGetCompanyPropertyWhitelistedDomainsQuery;
const saveCompanyProperty = async ({ companyId, key, value }) => {
    if (key === appConstants_1.companyPropertiesExtendedConstants.removeWhiteListedDomain) {
        return await companyRepository_1.default.deleteCompanyPropertyWhitelistedDomain({
            companyId,
            domain: value,
        });
    }
    else if (key === appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain) {
        await companyRepository_1.default.saveCompanyPropertyWhitelistedDomain({
            companyId,
            domain: value,
        });
    }
    else {
        await companyRepository_1.default.saveCompanyProperty({
            companyId,
            key,
            value,
        });
    }
};
const useSaveCompanyPropertyQuery = () => {
    return (0, react_query_1.useMutation)({ mutationFn: saveCompanyProperty });
};
exports.useSaveCompanyPropertyQuery = useSaveCompanyPropertyQuery;
const getRequestLimitQuery = () => {
    const propertyKey = appConstants_1.companyPropertyKeys.requestLimit;
    return {
        queryKey: [exports.companyKeys.getRequestLimit, propertyKey],
        queryFn: async () => {
            const userData = await Root_1.queryClient.ensureQueryData(userQuery_1.userQuery);
            return companyRepository_1.default.getCompanyProperty({
                companyAccountId: userData?.companyAccountId,
                propertyKey,
            });
        },
    };
};
exports.getRequestLimitQuery = getRequestLimitQuery;
const useGetRequestLimitQuery = () => {
    return (0, react_query_1.useQuery)((0, exports.getRequestLimitQuery)());
};
exports.useGetRequestLimitQuery = useGetRequestLimitQuery;
const companyPropertiesQuery = (companyId, properties) => (0, react_query_1.queryOptions)({
    queryKey: [exports.companyKeys.getProperties, companyId, properties],
    queryFn: () => getCompanyProperties(companyId || '', properties),
    enabled: Boolean(companyId),
});
exports.companyPropertiesQuery = companyPropertiesQuery;
async function getCompanyProperties(companyId, properties) {
    const promises = Object.entries(appConstants_1.companyPropertiesConstants).map(async ([propertyKey, keyValue]) => {
        const promise = keyValue === properties['whiteListedDomains']
            ? companyRepository_1.default.getCompanyPropertyWhitelistedDomains({ companyId })
            : companyRepository_1.default.getCompanyProperty({ companyAccountId: companyId, propertyKey: keyValue });
        return promise.then(value => {
            return { propertyKey, value };
        });
    });
    const results = await Promise.allSettled(promises);
    const filteredResults = results.filter(result => result.status === 'fulfilled');
    return filteredResults.reduce((acc, result) => {
        acc[result.value.propertyKey] =
            result.value.propertyKey === 'defaultExpirationDate' && typeof result.value.value === 'object'
                ? ''
                : result.value.value;
        return acc;
    }, {});
}
